import { useMemo } from 'react'

import { useUserApi } from '@/api/useUserApi'
import useCartStore from '@/app/book/stores/useCartStore'
import useSessionStore from '@/stores/useSessionStore'

export interface UseCartUser {
  user: {
    email: string
    name: string
    phone: string
  }
}

export const useCartUser = (): UseCartUser => {
  const userAuthToken = useSessionStore((store) => store.authToken)
  const sessionStoreHasHydrated = useSessionStore((store) => store.hasHydrated)
  const userRoles = useSessionStore((store) => store.userRoles)
  const isGuestUser = userRoles.includes('guest_user')

  const isUserApiEnabled = useMemo(
    () => (sessionStoreHasHydrated ? !!userAuthToken && !isGuestUser : false),
    [sessionStoreHasHydrated, userAuthToken, isGuestUser],
  )

  const { data: userData } = useUserApi(isUserApiEnabled)
  const impersonatingUser = useCartStore((store) => store.impersonatingUser)

  const userName = userData ? `${userData.firstName} ${userData.lastName}`.trim() : undefined
  const name = isGuestUser ? '' : impersonatingUser?.name || userName || ''
  const phone = isGuestUser ? '' : impersonatingUser?.phoneNumber || userData?.phoneNumber || ''
  const email = isGuestUser ? '' : impersonatingUser?.email || userData?.email || ''

  const user = useMemo(() => ({ name, phone, email }), [name, phone, email])

  return { user }
}
